<template>
  <div :class="['images-block', alignmentClass]">
    <p v-if="heading" class="text-lg text-center text-uppercase">
      {{ heading }}
    </p>

    <div
      class="slideshow"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >
      <!-- Image -->
      <transition name="fade" mode="out-in">
        <figure
          :key="currentImage.id"
          class="slide"
        >
          <img
            :src="currentImage.url"
            :alt="currentImage.title || heading"
            :width="currentImage.width"
            :height="currentImage.height"
            loading="lazy"
          />

          <figcaption
            class="image-caption text-sm text-family-secondary"
          >
            {{ currentImage.caption || '\u00A0' }}
          </figcaption>
        </figure>
      </transition>

      <!-- Arrows -->
      <div class="arrow-wrapper" v-if="images.length > 1">
        <button class="arrow left" @click="prev">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><circle cx="15" cy="15" r="14.5" fill="#fff" stroke="#212" transform="matrix(-1 0 0 1 30 0)"/><path stroke="#231f20" d="m17.25 20.737-6.11-6.243L17.25 8.25"/></svg>        
        </button>
        <button class="arrow right" @click="next">
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="none" viewBox="0 0 30 30"><circle cx="15" cy="15" r="14.5" fill="#fff" stroke="#212"/><path stroke="#231f20" d="m12.75 20.737 6.11-6.243L12.75 8.25"/></svg>        
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  heading: { type: String, default: null },
  alignment: { type: String, default: 'left' },
  images: { type: Array, required: true }
})

const currentIndex = ref(0)
const touchStartX = ref(0)

const currentImage = computed(() => {
  return props.images[currentIndex.value]
})

const next = () => {
  currentIndex.value =
    (currentIndex.value + 1) % props.images.length
}

const prev = () => {
  currentIndex.value =
    (currentIndex.value - 1 + props.images.length) %
    props.images.length
}

/* Swipe handling */
const onTouchStart = (e) => {
  touchStartX.value = e.changedTouches[0].screenX
}

const onTouchEnd = (e) => {
  const deltaX = e.changedTouches[0].screenX - touchStartX.value
  if (Math.abs(deltaX) > 50) {
    deltaX > 0 ? prev() : next()
  }
}

const alignmentClass = computed(() => {
  if (props.alignment === 'center') return 'col-12 col-sm-6 offset-sm-3'
  if (props.alignment === 'right') return 'col-12 col-sm-6 offset-sm-6'
  return 'col-12 col-sm-6'
})
</script>


